// src/theme/palette.js
import { createTheme } from "@mui/material/styles";
import { common, grey } from "@mui/material/colors";

// We need a "defaultTheme" to access `.palette.augmentColor(...)`.
const defaultTheme = createTheme();

const palette = {
  // Light or dark mode goes here
  background: {
    default: "#F1F5F8",
    paper: "#FFFFFF",
  },
  selectionSnackbar: {
    bg: "#252628",
    text: "#ffffff",
    disabledBg: "#666666",
    disabledText: "#999999",
    iconButton: {
      color: common.white,
      bgHover: grey[800],
    },
  },
  primary: {
    main: "#1B6DE6",
  },
  secondary: {
    main: "#c8b7cb",
  },
  // Then your custom "augmentColor" calls:
  black: defaultTheme.palette.augmentColor({
    color: { main: "#000000" },
    name: "black",
  }),
  white: defaultTheme.palette.augmentColor({
    color: { main: "#FFFFFF" },
    name: "white",
  }),
  green: defaultTheme.palette.augmentColor({
    color: { main: "#41a11a" },
    name: "green",
  }),
  red: defaultTheme.palette.augmentColor({
    color: { main: "#FF1E4B" },
    name: "red",
  }),
  lightBlue: defaultTheme.palette.augmentColor({
    color: { main: "#F1F9FD" },
    name: "lightBlue",
  }),
  danube: defaultTheme.palette.augmentColor({
    color: { main: "#64AAD0" },
    name: "danube",
  }),
  pink: defaultTheme.palette.augmentColor({
    color: { main: "#ec4d96" },
    name: "pink",
  }),
  divGrey: defaultTheme.palette.augmentColor({
    color: { main: "#F1F5F8" },
    name: "divGrey",
  }),
  lightGrey: defaultTheme.palette.augmentColor({
    color: { main: "#BBC2CD" },
    name: "lightGrey",
  }),
  darkGrey: defaultTheme.palette.augmentColor({
    color: { main: "#525964" },
    name: "darkGrey",
  }),
  darkBlue: defaultTheme.palette.augmentColor({
    color: { main: "#002864" },
    name: "darkBlue",
  }),
  orange: defaultTheme.palette.augmentColor({
    color: { main: "#FFB978" },
    name: "orange",
  }),
  blue: defaultTheme.palette.augmentColor({
    color: { main: "#1B6DE6" },
    name: "blue",
  }),
  lightGreen: defaultTheme.palette.augmentColor({
    color: { main: "#F1FDF4" },
    name: "lightGreen",
  }),
  lightRed: defaultTheme.palette.augmentColor({
    color: { main: "#FFE8EE" },
    name: "lightRed",
  }),
  highlightYellow: defaultTheme.palette.augmentColor({
    color: { main: "#FEEA99" },
    name: "highlightYellow",
  }),
  warningBackground: "#FBE9DB",

  // Statuses
  request: defaultTheme.palette.augmentColor({
    color: { main: "#BBC2CD", contrastText: "#FFFFFF" },
    name: "request",
  }),
  inQueue: defaultTheme.palette.augmentColor({
    color: { main: "#1FADCB", contrastText: "#FFFFFF" },
    name: "inQueue",
  }),
  onHold: defaultTheme.palette.augmentColor({
    color: { main: "#9099A3", contrastText: "#FFFFFF" },
    name: "onHold",
  }),
  notifyCustomer: defaultTheme.palette.augmentColor({
    color: { main: "#525964", contrastText: "#FFFFFF" },
    name: "notifyCustomer",
  }),
  orderParts: defaultTheme.palette.augmentColor({
    color: { main: "#FEB954", contrastText: "#000000" },
    name: "orderParts",
  }),
  waitingForParts: defaultTheme.palette.augmentColor({
    color: { main: "#F59606", contrastText: "#FFFFFF" },
    name: "waitingForParts",
  }),
  diagnose: defaultTheme.palette.augmentColor({
    color: { main: "#61DEAA", contrastText: "#000000" },
    name: "diagnose",
  }),
  qualityAssurance: defaultTheme.palette.augmentColor({
    color: { main: "#05BB6F", contrastText: "#FFFFFF" },
    name: "qualityAssurance",
  }),
  inRepair: defaultTheme.palette.augmentColor({
    color: { main: "#009758", contrastText: "#FFFFFF" },
    name: "inRepair",
  }),
  readyForPickUp: defaultTheme.palette.augmentColor({
    color: { main: "#6099EE", contrastText: "#FFFFFF" },
    name: "readyForPickUp",
  }),
  inDelivery: defaultTheme.palette.augmentColor({
    color: { main: "#1B6DE6", contrastText: "#FFFFFF" },
    name: "inDelivery",
  }),
  deliveredToCustomer: defaultTheme.palette.augmentColor({
    color: { main: "#084FB8", contrastText: "#FFFFFF" },
    name: "deliveredToCustomer",
  }),
  delivered: defaultTheme.palette.augmentColor({
    color: { main: "#084FB8", contrastText: "#FFFFFF" },
    name: "delivered",
  }),
  receivedFromPartner: defaultTheme.palette.augmentColor({
    color: { main: "#2979ff", contrastText: "#FFFFFF" },
    name: "receivedFromPartner",
  }),
  accepted: defaultTheme.palette.augmentColor({
    color: { main: "#41a11a" },
    name: "accepted",
  }),
};

palette.error = defaultTheme.palette.error;
palette.warning = defaultTheme.palette.warning;
palette.info = defaultTheme.palette.info;
palette.success = defaultTheme.palette.success;

export default palette;
